import React from 'react';
import { SvgIconProps } from '@mui/material';

export const MicrosoftLogoIcon: React.FC<SvgIconProps> = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        {...props}
    >
        <path fill="#f25022" d="M2 2h9.5v9.5H2z" />
        <path fill="#00a4ef" d="M12.5 2H22v9.5h-9.5z" />
        <path fill="#7fba00" d="M2 12.5h9.5V22H2z" />
        <path fill="#ffb900" d="M12.5 12.5H22V22h-9.5z" />
    </svg>
);

export default MicrosoftLogoIcon;
